import { render, staticRenderFns } from "./Tarjas.vue?vue&type=template&id=3d4e8015&"
import script from "./Tarjas.vue?vue&type=script&lang=js&"
export * from "./Tarjas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports